// Module
var code = " <gh-page layout=\"catalog\"> <gh-page-header icon=\"gh:setup\" parentTitle=\"{{'lbl_setup' | translate}}\" [pageTitle]=\"parentTitle\"> </gh-page-header> <gh-page-content> <gh-user-list-tab class=\"flex-1 flex-column\"></gh-user-list-tab> </gh-page-content> </gh-page> ";
// Exports
module.exports = code;